module.exports = __webpack_public_path__ + "static/media/Sweden.c2b07761.png";